export default {
  // Maintenance - 维修管理
  'repair.maintenance.headerTitle': '报修工单管理',
  'repair.maintenance.action.create': '新建工单',
  'repair.maintenance.action.batchDelete': '批量删除',
  'repair.maintenance.action.startProcess': '开始处理',
  'repair.maintenance.action.complete': '处理完成',
  'repair.maintenance.action.manageProgress': '进度管理',
  'repair.maintenance.action.view': '查看',
  'repair.maintenance.action.edit': '编辑',
  'repair.maintenance.action.delete': '删除',
  'repair.maintenance.column.workOrderNo': '工单编号',
  'repair.maintenance.column.repairType': '维修类型',
  'repair.maintenance.column.urgeCount': '催单次数',
  'repair.maintenance.column.repairImages': '报修图片',
  'repair.maintenance.column.title': '标题',
  'repair.maintenance.column.description': '维修描述',
  'repair.maintenance.column.status': '工单状态',
  'repair.maintenance.column.createdTime': '创建时间',
  'repair.maintenance.column.action': '操作',
  'repair.maintenance.confirm.batchDelete': '确定要批量删除选中的工单吗？',
  'repair.maintenance.confirm.ok': '确定',
  'repair.maintenance.confirm.cancel': '取消',
  'repair.maintenance.message.getRepairTypeFailed': '获取维修类型失败',
  'repair.maintenance.message.getStatusFailed': '获取工单状态失败',
  'repair.maintenance.message.deleteSuccess': '删除成功',
  'repair.maintenance.message.deleteFailed': '删除失败',
  'repair.maintenance.message.batchDeleteSuccess': '批量删除成功',
  'repair.maintenance.message.batchDeleteFailed': '批量删除失败',
  'repair.maintenance.message.startProcessSuccess': '工单已转为处理中',
  'repair.maintenance.message.startProcessFailed': '状态变更失败',
  'repair.maintenance.message.completeSuccess': '工单已完成',
  'repair.maintenance.message.completeFailed': '完成工单失败',
  'repair.maintenance.message.getProgressListFailed': '获取进度列表失败',
  'repair.maintenance.message.addProgressSuccess': '进度添加成功',
  'repair.maintenance.message.addProgressFailed': '进度添加失败',
  'repair.maintenance.message.deleteProgressSuccess': '进度删除成功',
  'repair.maintenance.message.deleteProgressFailed': '进度删除失败',

  // Maintenance Drawer - Start Process
  'repair.maintenance.drawer.startProcess.title': '开始处理工单',
  'repair.maintenance.drawer.startProcess.section.basic': '工单基本信息',
  'repair.maintenance.drawer.startProcess.section.owner': '业主信息',
  'repair.maintenance.drawer.startProcess.section.repair': '报修信息',
  'repair.maintenance.drawer.startProcess.section.images': '报修图片',
  'repair.maintenance.drawer.startProcess.section.system': '系统信息',
  'repair.maintenance.drawer.startProcess.label.workOrderNo': '工单编号',
  'repair.maintenance.drawer.startProcess.label.repairType': '维修类型',
  'repair.maintenance.drawer.startProcess.label.status': '工单状态',
  'repair.maintenance.drawer.startProcess.label.urgeCount': '催单次数',
  'repair.maintenance.drawer.startProcess.label.ownerName': '业主姓名',
  'repair.maintenance.drawer.startProcess.label.ownerPhone': '业主电话',
  'repair.maintenance.drawer.startProcess.label.ownerEmail': '业主邮箱',
  'repair.maintenance.drawer.startProcess.label.title': '标题',
  'repair.maintenance.drawer.startProcess.label.description': '描述内容',
  'repair.maintenance.drawer.startProcess.label.createdTime': '创建时间',
  'repair.maintenance.drawer.startProcess.label.updatedTime': '更新时间',
  'repair.maintenance.drawer.startProcess.label.remark': '备注信息',
  'repair.maintenance.drawer.startProcess.placeholder.remark':
    '请输入开始处理的备注信息，说明处理计划、预计时间等',
  'repair.maintenance.drawer.startProcess.rule.remarkRequired':
    '请输入处理备注',
  'repair.maintenance.drawer.startProcess.button.submit': '开始处理',
  'repair.maintenance.drawer.startProcess.button.cancel': '取消',

  // Maintenance Drawer - Complete
  'repair.maintenance.drawer.complete.title': '处理完成',
  'repair.maintenance.drawer.complete.section.basic': '工单基本信息',
  'repair.maintenance.drawer.complete.section.owner': '业主信息',
  'repair.maintenance.drawer.complete.section.repair': '报修信息',
  'repair.maintenance.drawer.complete.section.images': '报修图片',
  'repair.maintenance.drawer.complete.section.system': '系统信息',
  'repair.maintenance.drawer.complete.label.workOrderNo': '工单编号',
  'repair.maintenance.drawer.complete.label.repairType': '维修类型',
  'repair.maintenance.drawer.complete.label.status': '工单状态',
  'repair.maintenance.drawer.complete.label.urgeCount': '催单次数',
  'repair.maintenance.drawer.complete.label.ownerName': '业主姓名',
  'repair.maintenance.drawer.complete.label.ownerPhone': '业主电话',
  'repair.maintenance.drawer.complete.label.ownerEmail': '业主邮箱',
  'repair.maintenance.drawer.complete.label.title': '标题',
  'repair.maintenance.drawer.complete.label.description': '描述内容',
  'repair.maintenance.drawer.complete.label.createdTime': '创建时间',
  'repair.maintenance.drawer.complete.label.updatedTime': '更新时间',
  'repair.maintenance.drawer.complete.label.remarks': '备注',
  'repair.maintenance.drawer.complete.label.remark': '完成备注',
  'repair.maintenance.drawer.complete.placeholder.remark':
    '请输入处理完成的备注信息，说明完成情况、处理结果等',
  'repair.maintenance.drawer.complete.rule.remarkRequired': '请输入完成备注',
  'repair.maintenance.drawer.complete.button.submit': '确认完成',
  'repair.maintenance.drawer.complete.button.cancel': '取消',

  // Maintenance Drawer - Progress Management
  'repair.maintenance.drawer.progress.title': '工单进度管理',
  'repair.maintenance.drawer.progress.section.basic': '工单基本信息',
  'repair.maintenance.drawer.progress.section.progressList': '进度记录',
  'repair.maintenance.drawer.progress.section.addProgress': '添加新进度',
  'repair.maintenance.drawer.progress.label.workOrderNo': '工单编号',
  'repair.maintenance.drawer.progress.label.repairType': '维修类型',
  'repair.maintenance.drawer.progress.label.status': '工单状态',
  'repair.maintenance.drawer.progress.label.title': '标题',
  'repair.maintenance.drawer.progress.label.progressContent': '进度内容',
  'repair.maintenance.drawer.progress.placeholder.progressContent':
    '请输入进度内容',
  'repair.maintenance.drawer.progress.button.addProgress': '添加进度',
  'repair.maintenance.drawer.progress.button.delete': '删除',
  'repair.maintenance.drawer.progress.confirm.deleteProgress':
    '确定要删除这条进度吗？',
  'repair.maintenance.drawer.progress.empty': '暂无进度记录',
  'repair.maintenance.drawer.progress.label.newProgress': '新进度说明',
  'repair.maintenance.drawer.progress.placeholder.newProgress':
    '请输入本次处理的进度说明',
  'repair.maintenance.drawer.progress.rule.progressRequired': '请输入进度说明',
  'repair.maintenance.drawer.progress.button.submit': '提交进度',
  'repair.maintenance.drawer.progress.button.close': '关闭',

  // Maintenance Detail Modal
  'repair.maintenance.modal.detail.title': '工单详情',
  'repair.maintenance.modal.detail.section.basic': '工单基本信息',
  'repair.maintenance.modal.detail.section.owner': '业主信息',
  'repair.maintenance.modal.detail.section.repair': '报修信息',
  'repair.maintenance.modal.detail.section.images': '报修图片',
  'repair.maintenance.modal.detail.section.system': '系统信息',
  'repair.maintenance.modal.detail.label.workOrderNo': '工单编号',
  'repair.maintenance.modal.detail.label.repairType': '维修类型',
  'repair.maintenance.modal.detail.label.status': '工单状态',
  'repair.maintenance.modal.detail.label.urgeCount': '催单次数',
  'repair.maintenance.modal.detail.label.ownerName': '业主姓名',
  'repair.maintenance.modal.detail.label.ownerPhone': '业主电话',
  'repair.maintenance.modal.detail.label.ownerEmail': '业主邮箱',
  'repair.maintenance.modal.detail.label.title': '标题',
  'repair.maintenance.modal.detail.label.description': '描述内容',
  'repair.maintenance.modal.detail.label.createdTime': '创建时间',
  'repair.maintenance.modal.detail.label.updatedTime': '更新时间',
  'repair.maintenance.modal.detail.label.remarks': '备注',

  // Maintenance Form
  'repair.maintenance.form.create.title': '新建报修工单',
  'repair.maintenance.form.edit.title': '编辑报修工单',
  'repair.maintenance.form.label.workOrderNo': '工单编号',
  'repair.maintenance.form.placeholder.workOrderNo': '系统自动生成（可不填）',
  'repair.maintenance.form.tooltip.workOrderNo':
    '如果不填写，系统将自动生成工单编号',
  'repair.maintenance.form.label.repairType': '维修类型',
  'repair.maintenance.form.placeholder.repairType': '请选择维修类型',
  'repair.maintenance.form.rule.repairTypeRequired': '请选择维修类型',
  'repair.maintenance.form.label.title': '标题',
  'repair.maintenance.form.placeholder.title': '请输入工单标题',
  'repair.maintenance.form.rule.titleRequired': '请输入工单标题',
  'repair.maintenance.form.rule.titleMaxLength': '标题不能超过100个字符',
  'repair.maintenance.form.label.description': '维修描述',
  'repair.maintenance.form.placeholder.description': '请详细描述报修问题',
  'repair.maintenance.form.label.ownerName': '业主姓名',
  'repair.maintenance.form.placeholder.ownerName': '请点击查询按钮选择业主',
  'repair.maintenance.form.tooltip.ownerName': '请点击右侧的查询按钮选择业主',
  'repair.maintenance.form.label.ownerPhone': '业主电话',
  'repair.maintenance.form.placeholder.ownerPhone': '请输入业主电话',
  'repair.maintenance.form.label.repairImages': '报修图片',
  'repair.maintenance.form.button.selectOwner': '选择业主',
  'repair.maintenance.form.button.submit': '提交',
  'repair.maintenance.form.button.cancel': '取消',

  // Owner Select Modal
  'repair.maintenance.ownerModal.title': '选择业主',
  'repair.maintenance.ownerModal.button.ok': '确定',
  'repair.maintenance.ownerModal.button.cancel': '取消',

  // Complaint - 投诉管理
  'repair.complaint.headerTitle': '投诉管理',
  'repair.complaint.action.create': '新建投诉',
  'repair.complaint.action.batchDelete': '批量删除',
  'repair.complaint.action.startProcess': '开始处理',
  'repair.complaint.action.complete': '处理完成',
  'repair.complaint.action.manageProgress': '进度管理',
  'repair.complaint.action.view': '查看',
  'repair.complaint.action.edit': '编辑',
  'repair.complaint.action.delete': '删除',
  'repair.complaint.column.complaintNo': '投诉编号',
  'repair.complaint.column.complaintType': '投诉类型',
  'repair.complaint.column.urgeCount': '催单次数',
  'repair.complaint.column.complaintImages': '投诉图片',
  'repair.complaint.column.title': '标题',
  'repair.complaint.column.description': '投诉描述',
  'repair.complaint.column.status': '投诉状态',
  'repair.complaint.column.createdTime': '创建时间',
  'repair.complaint.column.action': '操作',
  'repair.complaint.confirm.batchDelete': '确定要批量删除选中的投诉记录吗？',
  'repair.complaint.confirm.ok': '确定',
  'repair.complaint.confirm.cancel': '取消',

  // Complaint Drawer - Start Process
  'repair.complaint.drawer.startProcess.title': '开始处理投诉',
  'repair.complaint.drawer.startProcess.placeholder.remark':
    '请输入开始处理的备注信息，说明处理计划、预计时间等',

  // Complaint Drawer - Complete
  'repair.complaint.drawer.complete.title': '处理完成',
  'repair.complaint.drawer.complete.placeholder.remark':
    '请输入处理完成的备注信息，说明完成情况、处理结果等',

  // Complaint Drawer - Progress Management
  'repair.complaint.drawer.progress.title': '投诉进度管理',
  'repair.complaint.drawer.progress.placeholder.progressContent':
    '请输入进度内容',
  'repair.complaint.drawer.progress.placeholder.newProgress':
    '请输入本次处理的进度说明',
  'repair.complaint.drawer.progress.confirm.deleteProgress':
    '确定要删除这条进度吗？',

  // Complaint Detail Modal
  'repair.complaint.modal.detail.title': '投诉详情',

  // Complaint Form
  'repair.complaint.form.create.title': '新建投诉记录',
  'repair.complaint.form.edit.title': '编辑投诉记录',
  'repair.complaint.form.label.complaintNo': '投诉编号',
  'repair.complaint.form.placeholder.complaintNo': '系统自动生成（可不填）',
  'repair.complaint.form.tooltip.complaintNo':
    '如果不填写，系统将自动生成投诉编号',
  'repair.complaint.form.label.complaintType': '投诉类型',
  'repair.complaint.form.placeholder.complaintType': '请选择投诉类型',
  'repair.complaint.form.rule.complaintTypeRequired': '请选择投诉类型',
  'repair.complaint.form.label.title': '标题',
  'repair.complaint.form.placeholder.title': '请输入投诉标题',
  'repair.complaint.form.rule.titleRequired': '请输入投诉标题',
  'repair.complaint.form.rule.titleMaxLength': '标题不能超过100个字符',
  'repair.complaint.form.label.description': '投诉描述',
  'repair.complaint.form.placeholder.description': '请详细描述投诉问题',
  'repair.complaint.form.label.complainantName': '投诉人姓名',
  'repair.complaint.form.placeholder.complainantName':
    '请点击查询按钮选择投诉人',
  'repair.complaint.form.tooltip.complainantName':
    '请点击右侧的查询按钮选择投诉人',
  'repair.complaint.form.label.complainantPhone': '投诉人电话',
  'repair.complaint.form.placeholder.complainantPhone': '请输入投诉人电话',
  'repair.complaint.form.label.complaintImages': '投诉图片',
  'repair.complaint.form.button.selectComplainant': '选择投诉人',

  // Complainant Select Modal
  'repair.complaint.complainantModal.title': '选择投诉人',
  'repair.maintenance.title': '维修工单',
  'repair.complaint.title': '投诉记录',
};
